import { Field, RadioPills, Honeypot, SubmitButton, SuccessPanel, inputCls, useEnquiry } from "@/components/forms/fields";

const INTERESTED_IN = ["Ducted Air Conditioning", "Split System", "Multi Head", "VEU Rebate Upgrade", "Warranty", "Not Sure"];
const EXISTING = ["Gas Ducted", "Gas Space Heater", "Split System", "Ducted Air Conditioning", "Electric Heating", "No Existing System", "Other"];
const PROPERTY = ["House", "Townhouse", "Apartment", "Commercial", "Other"];
const PREFERRED = ["Phone", "Email"];

export default function QuoteForm() {
  const { data, set, errors, status, submit, reset, formProps } = useEnquiry(
    "quote",
    ["first_name", "last_name", "phone", "email", "address", "suburb", "postcode", "consent"],
    "/contact"
  );

  if (status === "success")
    return (
      <SuccessPanel
        testid="quote-form-success"
        title="Thank you — your quote request has been received."
        message="Our team will review your details and contact you to discuss the right air conditioning solution for your property."
        onReset={reset}
      />
    );

  return (
    <form onSubmit={submit} {...formProps} noValidate data-testid="quote-form" className="space-y-5">
      <Honeypot value={data.website || ""} onChange={(v) => set("website", v)} />
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="First Name" required error={errors.first_name}>
          <input data-testid="quote-first-name" className={inputCls} value={data.first_name || ""} onChange={(e) => set("first_name", e.target.value)} autoComplete="given-name" />
        </Field>
        <Field label="Last Name" required error={errors.last_name}>
          <input data-testid="quote-last-name" className={inputCls} value={data.last_name || ""} onChange={(e) => set("last_name", e.target.value)} autoComplete="family-name" />
        </Field>
        <Field label="Phone" required error={errors.phone}>
          <input data-testid="quote-phone" type="tel" className={inputCls} value={data.phone || ""} onChange={(e) => set("phone", e.target.value)} autoComplete="tel" />
        </Field>
        <Field label="Email" required error={errors.email}>
          <input data-testid="quote-email" type="email" className={inputCls} value={data.email || ""} onChange={(e) => set("email", e.target.value)} autoComplete="email" />
        </Field>
      </div>
      <Field label="Installation Address" required error={errors.address}>
        <input data-testid="quote-address" className={inputCls} value={data.address || ""} onChange={(e) => set("address", e.target.value)} autoComplete="street-address" />
      </Field>
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Suburb" required error={errors.suburb}>
          <input data-testid="quote-suburb" className={inputCls} value={data.suburb || ""} onChange={(e) => set("suburb", e.target.value)} />
        </Field>
        <Field label="Postcode" required error={errors.postcode}>
          <input data-testid="quote-postcode" inputMode="numeric" className={inputCls} value={data.postcode || ""} onChange={(e) => set("postcode", e.target.value)} autoComplete="postal-code" />
        </Field>
      </div>
      <Field label="Interested In">
        <RadioPills testid="quote-interested" options={INTERESTED_IN} value={data.interested_in} onChange={(v) => set("interested_in", v)} />
      </Field>
      <Field label="Existing Heating / Cooling">
        <RadioPills testid="quote-existing" options={EXISTING} value={data.existing_system} onChange={(v) => set("existing_system", v)} />
      </Field>
      <Field label="Property">
        <RadioPills testid="quote-property" options={PROPERTY} value={data.property} onChange={(v) => set("property", v)} />
      </Field>
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Number of Bedrooms">
          <input data-testid="quote-bedrooms" inputMode="numeric" className={inputCls} value={data.bedrooms || ""} onChange={(e) => set("bedrooms", e.target.value)} />
        </Field>
        <Field label="Number of Storeys">
          <input data-testid="quote-storeys" inputMode="numeric" className={inputCls} value={data.storeys || ""} onChange={(e) => set("storeys", e.target.value)} />
        </Field>
      </div>
      <Field label="Preferred Contact Method">
        <RadioPills testid="quote-preferred-contact" options={PREFERRED} value={data.preferred_contact} onChange={(v) => set("preferred_contact", v)} />
      </Field>
      <Field label="Message">
        <textarea data-testid="quote-message" rows={4} className={inputCls} value={data.message || ""} onChange={(e) => set("message", e.target.value)} placeholder="Tell us about your home and what you'd like to achieve…" />
      </Field>
      <Field label="" error={errors.consent}>
        <span className="flex items-start gap-3">
          <input
            data-testid="quote-consent"
            type="checkbox"
            checked={!!data.consent}
            onChange={(e) => set("consent", e.target.checked ? "Yes" : "")}
            className="mt-0.5 h-5 w-5 shrink-0 rounded border-line accent-[#008CC4]"
          />
          <span className="text-xs leading-relaxed text-mutedblue">
            I agree to be contacted regarding my enquiry.
          </span>
        </span>
      </Field>
      <SubmitButton status={status} testid="quote-submit-btn">Request My Free Quote</SubmitButton>
    </form>
  );
}
